module.exports = __webpack_public_path__ + "static/join-small-96ced3ccabeb939aace145973f476505.webp";